var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.886950538,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s_mobile-18",
    transform: "translate(-330.000000, -32.000000)",
    stroke: "#34AB53",
    strokeWidth: 3.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(332.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.44,
    y1: 0.5,
    x2: 21.56,
    y2: 0.5,
    id: "Line-2-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3928571,
    y1: 10.5,
    x2: 21.5757143,
    y2: 10.5,
    id: "Line-2-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.44,
    y1: 20.5,
    x2: 21.56,
    y2: 20.5,
    id: "Line-2-Copy-2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburgerIcon.37555863cfdbab2a066d6ceb0a7f3375.svg";
export { ForwardRef as ReactComponent };